<p-fieldset legend="Aviso do Edital 2a. Fase">
  <div class="row">
    <label class="required col-12 col-form-label">
      Houve autorização para abertura do edital da 2a. Fase?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
      [(ngModel)]="entidade.ExisteAutorizacaoAberturaEdital2aFase" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <lib-licitacao-audesp-publicacao [entidade]="entidade" [campo]="'AvisoEdital2aFasePublicacao'"
    *ngIf="entidade.ExisteAutorizacaoAberturaEdital2aFase === 'S'"></lib-licitacao-audesp-publicacao>
</p-fieldset>
<p-fieldset legend="Edital 2a. Fase">
  <div class="row">
    <label class="required col-3 col-form-label">
      Número do Edital
    </label>
    <input type="text" class="form-control col-3" [(ngModel)]="entidade.Edital2aFaseNumero"
      [ngModelOptions]="{standalone: true}">
    <label class="required col-2 col-form-label">
      Data do Edital
    </label>
    <p-calendar (onFocus)="onFocusDate()"[(ngModel)]="entidade.Edital2aFaseDt" [ngModelOptions]="{standalone: true}"
      inputStyleClass="form-control col-auto" dataType="string" dateFormat="dd/mm/yy" [showOnFocus]="true"
      [showButtonBar]="true" [showIcon]="true">
    </p-calendar>
  </div>
  <p-fieldset legend="Publicação do Edital em veículos de comunicação">
    <div class="row">
      <label class="required col-12 col-form-label">
        Houve publicação do Edital em veículos de comunicação?
      </label>
      <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
        [(ngModel)]="entidade.Edital2aFasePublicacaoNao" [ngModelOptions]="{standalone: true}">
        <ng-template let-opcao>
          <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
        </ng-template>
      </p-selectButton>
    </div>
    <lib-licitacao-audesp-publicacao [entidade]="entidade" [campo]="'Edital2aFasePublicacao'"
      *ngIf="entidade.Edital2aFasePublicacaoNao === 'S'">
    </lib-licitacao-audesp-publicacao>
  </p-fieldset>
</p-fieldset>
<p-fieldset legend="Garantia para participação da licitação">
  <div class="row">
    <label class="required col-12 col-form-label">
      Há exigência de garantia para participação da licitação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
      [(ngModel)]="entidade.ExisteExigenciaGarantiaParticipacaoLicitacao" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>